<template>
  <v-autocomplete
    v-model="inputedValue"
    :items="items"
    item-text="label"
    item-value="value"
    :placeholder="$t('common.input_unselected_2')"
    class="original-selectbox"
    outlined
    return-object
    dense
    hide-details
    :height="height"
    width="80%"
    :disabled="disabled"
    :filled="disabled"
    :no-data-text="$t('common.common_no-data')"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    //
  },
  props: {
    value: {
      type: Object,
      require: true,
      default: () => ({})
    },
    height: { default: '32px' },
    disabled: { default: false }
  },
  data: () => ({
    items: []
  }),
  created() {
    this.setIsLoading(true)
    const list = this.getCountryListFromState()

    this.items = list.map((ele) => {
      return { label: ele.name, value: ele.countryId }
    })
    this.setIsLoading(false)
  },
  methods: {
    ...mapGetters('Common', ['getCountryListFromState']),
    ...mapActions('Common', ['setIsLoading'])
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        if (!newValue) {
          newValue = {
            label: '',
            value: null
          }
        }

        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style scoped lang="scss"></style>
